export default "__VITE_ASSET__DPeDtzoN__"